module.exports = __webpack_public_path__ + "img/area.64285085.svg";